import { useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { EmptyState, Skeleton } from '@/components';
import { AddonAppFrame } from './components';
import { useAddonApps } from './hooks';
import { resolveAddonAppPageState } from './utils/addonAppPageState';

// Shows the addon app selected in the route; covers loading, load error and unknown slug
export function AddonAppPage() {
  const { t } = useTranslation();
  const { appSlug } = useParams({ from: '/_app/apps/$appSlug' });
  const { data: addonApps, isLoading, isError } = useAddonApps();
  const pageState = resolveAddonAppPageState({ addonApps, isLoading, isError, slug: appSlug });

  switch (pageState.kind) {
    case 'loading':
      return <Skeleton className="h-full w-full" />;
    case 'load-error':
      return <EmptyState title={t('addonApps.load-error')} />;
    case 'not-found':
      return <EmptyState title={t('addonApps.not-found')} />;
    case 'frame':
      // key forces a fresh iframe per app; changing src on a reused one adds a history entry
      return <AddonAppFrame key={pageState.addonApp.slug} addonApp={pageState.addonApp} />;
  }
}
